export type TSellerProfileAccessLevel = "VIEW" | "EDIT";

export type TSellerProfileAccess = {
  profilePublicId: string;
  accessLevel: TSellerProfileAccessLevel;
};

export type SellerFormData = {
  name: string;
  email: string;
  password?: string;
  level: string;
  status: string;
  id?: string;
  // undefined = nao alterar acessos (backend trata null como no-op);
  // lista vazia = remover todos os acessos do cliente.
  profileAccesses?: TSellerProfileAccess[];
};

export const buildSellerPayload = (sellerData: SellerFormData) => {
  const isActive = sellerData.status === "active";

  return {
    name: sellerData.name,
    email: sellerData.email,
    password: sellerData.password?.trim() || undefined,
    userType: sellerData.level,
    // "disabled" mapeia para indDeleted (exclusao logica), nao para login ativo.
    disabled: false,
    isActive,
    profileAccesses: sellerData.profileAccesses ?? null,
  };
};
